import React from "react";

type Feature = {
  heading: string;
  href: string;
  icon: string;
};

type FeaturesShowCaseCardsProps = {
  data: Feature[];
};

const FeaturesShowCaseCards = ({ data }: FeaturesShowCaseCardsProps) => {
  const List = () => {
    let theClasses: string | undefined;
    if (data.length === 3) {
      theClasses = "has-three-col";
    }
    if (data.length === 4) {
      theClasses = "has-four-col";
    }
    return (
      <div
        className={`container card--default card--feature lg:mt-10 md:mt-5 ${theClasses}`}
      >
        {data.map((item, count) => {
          let { heading, href, icon } = item;
          return (
            <a
              className="btn-outline md:mb-0 md:mt-0 md:pb-3 md:pl-2.5 md:pr-2 md:pt-2.5 md:mb-5 pb-4 pl-3 pr-3 pt-3 text-left bg:hover-white"
              href={href}
              key={count}
            >
              <div className="icon-title-wrap md:mb-0">
                <figure dangerouslySetInnerHTML={{ __html: icon }}></figure>
                <h3
                  className="lg:mt-3 lg:text-center md:text-left text-brandcolor"
                  dangerouslySetInnerHTML={{ __html: heading }}
                />
              </div>
            </a>
          );
        })}
      </div>
    );
  };

  return <List />;
};

export default FeaturesShowCaseCards;
